// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"c7-z","disabled":"d7-z","label":"e7-z"};